module.exports = __webpack_public_path__ + "static/media/lost.830431e4.png";